import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const motioneldConfig: TSPConfig = {
  key: 'motioneld',
  name: 'Motion ELD',
  imageName: 'motioneld',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Motion ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default motioneldConfig;
